module.exports = __webpack_public_path__ + "static/toys-2-d2fba68b4cc307c01d1fafb60e4bb378.jpg";